import { render, staticRenderFns } from "./ComparisonCriteria.vue?vue&type=template&id=5731625a&scoped=true"
import script from "./ComparisonCriteria.vue?vue&type=script&lang=js"
export * from "./ComparisonCriteria.vue?vue&type=script&lang=js"
import style0 from "./ComparisonCriteria.vue?vue&type=style&index=0&id=5731625a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731625a",
  null
  
)

export default component.exports